/* eslint-disable no-unused-vars */
import {
  getDigitalWalletValues,
  getFilteredEvents,
  getWithdrawals,
  getWithdrawalById,
  registerWithdrawal,
  sendToken,
  updateWithdrawal,
} from "@/api";
import { i18n } from "../../main";
const state = {
  modalNewWithdrawal: false,
  modalPayThirdParty: false,
  modalAnticipatedWithdrawal: false,
  currentStepDigitalWallet: 0,
  isEdit: false,

  filteredEvents: [],
  filteredEventsLoading: false,

  exportWalletCSVLoading: false,
  exportWalletPDFLoading: false,

  token: null,
  tokenLoading: false,

  values: {},
  valuesLoading: false,
  availableBalanceByEvent: 0,
  availableBalanceByEventLoading: false,
  awaitingRelease: 0,
  awaitingReleaseLoading: false,

  withdrawals: [],
  withdrawalsLoading: false,

  withdrawalData: {},
  withdrawalDataLoading: false,
};

const getters = {
  modalNewWithdrawal: state => state.modalNewWithdrawal,
  modalPayThirdParty: state => state.modalPayThirdParty,
  modalAnticipatedWithdrawal: state => state.modalAnticipatedWithdrawal,
  currentStepDigitalWallet: state => state.currentStepDigitalWallet,
  isEdit: state => state.isEdit,

  filteredEvents: state => state.filteredEvents,
  filteredEventsLoading: state => state.filteredEventsLoading,

  exportWalletCSVLoading: state => state.exportWalletCSVLoading,
  exportWalletPDFLoading: state => state.exportWalletPDFLoading,

  token: state => state.token,
  tokenLoading: state => state.tokenLoading,

  values: state => state.values,
  valuesLoading: state => state.valuesLoading,
  availableBalanceByEvent: state => state.availableBalanceByEvent,
  availableBalanceByEventLoading: state => state.availableBalanceByEventLoading,
  awaitingRelease: state => state.awaitingRelease,
  awaitingReleaseLoading: state => state.awaitingReleaseLoading,

  withdrawals: state => state.withdrawals,
  withdrawalsLoading: state => state.withdrawalsLoading,

  withdrawalData: state => state.withdrawalData,
  withdrawalDataLoading: state => state.withdrawalDataLoading,
};

const exportData = async (
  commit,
  apiFunction,
  fileType,
  reportName,
  params
) => {
  commit(`setExportWallet${fileType.toUpperCase()}Loading`, true);
  const exportType = fileType.toUpperCase();
  const type = fileType === "csv" ? "text/csv" : "application/pdf";

  try {
    const { pesquisar, idproduto, data_inicial, data_final } = params;

    const response = await apiFunction(
      pesquisar,
      idproduto,
      data_inicial,
      data_final,
      exportType
    );
    const file = new Blob([response.data], { type });
    const fileURL = URL.createObjectURL(file);
    if (fileType === "csv") {
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      a.href = fileURL;
      a.download = `Relatório ${reportName}`;
      a.click();
      window.URL.revokeObjectURL(fileURL);
    } else window.open(fileURL);
  } catch (error) {
    console.error(`Erro ao exportar dados: ${error.message}`);
  } finally {
    commit(`setExportWallet${fileType.toUpperCase()}Loading`, false);
  }
};

const actions = {
  toggleModalNewWithdrawal({ commit }) {
    commit("toggleModalNewWithdrawal");
    commit("setWithdrawalData", {});
    commit("setAvailableBalanceByEvent", 0);
  },
  toggleModalPayThirdParty({ commit }) {
    commit("toggleModalPayThirdParty");
    commit("setWithdrawalData", {});
    commit("setAvailableBalanceByEvent", 0);
  },
  toggleModalAnticipatedWithdrawal({ commit }) {
    commit("toggleModalAnticipatedWithdrawal");
    commit("setWithdrawalData", {});
    commit("setAwaitingRelease", 0);
  },

  resetStep({ commit }) {
    commit("setResetStep");
  },
  nextStep({ commit }) {
    commit("setNextStep");
  },
  previousStep({ commit }) {
    commit("setPreviousStep");
  },

  fetchFilteredEvents({ commit }) {
    commit("setFilteredEventsLoading", true);
    getFilteredEvents().then(response => {
      commit("setFilteredEvents", response.data);
      commit("setFilteredEventsLoading", false);
    });
  },

  sendToken({ commit, dispatch }) {
    commit("setTokenLoading", true);
    sendToken()
      .then(() => {
        commit("setTokenLoading", false);
        dispatch("showSnackbarInfo", i18n.t("digital-wallet.sent-token"));
      })
      .catch(() => {
        dispatch(
          "showSnackbarError",
          i18n.t("digital-wallet.sent-token-error")
        );
      });
  },

  fetchAvailableBalanceByEvent({ commit }, params) {
    const idproduto = params;
    commit("setAvailableBalanceByEventLoading", true);
    getDigitalWalletValues(idproduto).then(response => {
      commit("setAvailableBalanceByEventLoading", false);
      commit("setAvailableBalanceByEvent", response.data.saldo_disponivel);
    });
  },
  fetchAwaitingRelease({ commit }, params) {
    const idproduto = params;
    commit("setAwaitingReleaseLoading", true);
    getDigitalWalletValues(idproduto).then(response => {
      commit("setAwaitingReleaseLoading", false);
      commit("setAwaitingRelease", response.data.saldo_aguardando_liberacao);
    });
  },
  fetchValues({ commit }, params) {
    const { idproduto, dthr_ini, dthr_fim } = params;
    commit("setValuesLoading", true);
    getDigitalWalletValues(idproduto, dthr_ini, dthr_fim).then(response => {
      commit("setValuesLoading", false);
      commit("setValues", response.data);
    });
  },
  fetchWithdrawals({ commit }, params) {
    const { pesquisar, idproduto, data_inicial, data_final } = params;

    commit("setWithdrawalsLoading", true);
    getWithdrawals(pesquisar, idproduto, data_inicial, data_final).then(
      response => {
        commit("setWithdrawals", response.data);
        commit("setWithdrawalsLoading", false);
      }
    );
  },

  getWithdrawalById({ commit }, params) {
    const idcarteira_digital = params;

    commit("setWithdrawalDataLoading", true);
    getWithdrawalById(idcarteira_digital).then(response => {
      commit("setWithdrawalData", response.data);
      commit("setWithdrawalDataLoading", false);
    });
  },
  newWithdrawal({ commit, dispatch }, params) {
    const {
      idproduto,
      valor_saque,
      dthr_saque,
      token,
      destinatario,
      cpf_cnpj,
      banco,
      agencia,
      tipo_conta,
      numero_conta,
      digito_conta,
      tipo,
    } = params;

    commit("setWithdrawalDataLoading", true);
    registerWithdrawal(
      idproduto,
      valor_saque,
      dthr_saque,
      token,
      destinatario,
      cpf_cnpj,
      banco,
      agencia,
      tipo_conta,
      numero_conta,
      digito_conta,
      tipo
    )
      .then(response => {
        commit("setWithdrawalDataLoading", false);
        commit("setResetStep");
        commit("setWithdrawalData", {});

        dispatch(
          "showSnackbarSuccess",
          i18n.t("digital-wallet.success-payment-request")
        );
        dispatch("fetchWithdrawals", response.data);
        dispatch("fetchValues", response.data);
      })
      .catch(err => {
        let errorMessage = err.response.data.message;
        dispatch("showSnackbarError", errorMessage);
        commit("setWithdrawalDataLoading", false);
      });
  },

  updateWithdrawal({ commit, dispatch }, params) {
    const {
      idcarteira_digital,
      valor_saque,
      dthr_aprovacao,
      status,
      idusuario_solicitacao,
      tipo_usuario_solicitacao,
      idusuario_aprovacao,
      destinatario,
      cpf,
      cnpj,
      banco,
      agencia,
      tipo_conta,
      numero_conta,
      digito_conta,
      idproduto,
      comprovante,
      tipo,
    } = params;

    updateWithdrawal(
      idcarteira_digital,
      valor_saque,
      dthr_aprovacao,
      status,
      idusuario_solicitacao,
      tipo_usuario_solicitacao,
      idusuario_aprovacao,
      destinatario,
      cpf,
      cnpj,
      banco,
      agencia,
      tipo_conta,
      numero_conta,
      digito_conta,
      idproduto,
      comprovante,
      tipo
    )
      .then(response => {
        dispatch(
          "showSnackbarSuccess",
          i18n.t("digital-wallet.success-withdrawal-update")
        );
        dispatch("fetchWithdrawals", response.data);
        dispatch("fetchValues", response.data);
      })
      .catch(err => {
        let errorMessage = err.response.data.message;
        dispatch("showSnackbarError", errorMessage);
      });
  },
  submitWithdrawal({ commit, dispatch, getters }, params) {
    getters.isEdit
      ? dispatch("updateWithdrawal", params)
      : dispatch("newWithdrawal", params);

    commit("setWithdrawalData", {});
    commit("setIsEdit", false);
  },

  async exportWithdrawalCSV({ commit }, params) {
    await exportData(commit, getWithdrawals, "csv", "Saques", params);
  },
  async exportWithdrawalPDF({ commit }, params) {
    await exportData(commit, getWithdrawals, "pdf", "Saques", params);
  },
};

const mutations = {
  toggleModalNewWithdrawal(state) {
    state.modalNewWithdrawal = !state.modalNewWithdrawal;
  },
  toggleModalPayThirdParty(state) {
    state.modalPayThirdParty = !state.modalPayThirdParty;
  },
  toggleModalAnticipatedWithdrawal(state) {
    state.modalAnticipatedWithdrawal = !state.modalAnticipatedWithdrawal;
  },

  setResetStep(state) {
    state.currentStepDigitalWallet = 0;
  },
  setNextStep(state) {
    state.currentStepDigitalWallet = state.currentStepDigitalWallet + 1;
  },
  setPreviousStep(state) {
    state.currentStepDigitalWallet = state.currentStepDigitalWallet - 1;
  },

  setIsEdit(state, isEdit) {
    state.isEdit = isEdit;
  },

  setFilteredEvents(state, filteredEvents) {
    state.filteredEvents = filteredEvents;
  },
  setFilteredEventsLoading(state, filteredEventsLoading) {
    state.filteredEventsLoading = filteredEventsLoading;
  },

  setExportWalletCSVLoading(state, exportWalletCSVLoading) {
    state.exportWalletCSVLoading = exportWalletCSVLoading;
  },
  setExportWalletPDFLoading(state, exportWalletPDFLoading) {
    state.exportWalletPDFLoading = exportWalletPDFLoading;
  },

  setToken(state, token) {
    state.token = token;
  },
  setTokenLoading(state, tokenLoading) {
    state.tokenLoading = tokenLoading;
  },

  setValues(state, values) {
    state.values = values;
  },
  setValuesLoading(state, valuesLoading) {
    state.valuesLoading = valuesLoading;
  },
  setAvailableBalanceByEvent(state, availableBalanceByEvent) {
    state.availableBalanceByEvent = availableBalanceByEvent;
  },
  setAvailableBalanceByEventLoading(state, availableBalanceByEventLoading) {
    state.availableBalanceByEventLoading = availableBalanceByEventLoading;
  },
  setAwaitingRelease(state, awaitingRelease) {
    state.awaitingRelease = awaitingRelease;
  },
  setAwaitingReleaseLoading(state, awaitingReleaseLoading) {
    state.awaitingReleaseLoading = awaitingReleaseLoading;
  },

  setWithdrawals(state, withdrawals) {
    state.withdrawals = withdrawals;
  },
  setWithdrawalsLoading(state, withdrawalsLoading) {
    state.withdrawalsLoading = withdrawalsLoading;
  },

  setWithdrawalData(state, withdrawalData) {
    state.withdrawalData = withdrawalData;
  },
  setWithdrawalDataLoading(state, withdrawalDataLoading) {
    state.withdrawalDataLoading = withdrawalDataLoading;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
